<template>
  <div>
    <van-cell
      :title="title"
      is-link
      :value="displayValue"
      @click="disabled ? null : (showPicker = true)"
      :class="disabled ? 'not-go-index' : ''"
    />
    <van-popup class="showBtn" closeable v-model="showPicker" position="bottom">
      <van-picker
        :title="title"
        :item-height="getItemHeight"
        show-toolbar
        ref="picker"
        :columns="columns"
        @confirm="handleColumnChange"
        @cancel="showPicker = false"
        confirm-button-text="  "
        cancel-button-text=" "
        :class="{ h5picker: $store.state.vantPickeStyle }"
      >
        <template #columns-bottom>
          <div
            class="savebtn"
            :class="{
              PickxTabBar: $store.state.iphonex,
              androidTabBar: $store.state.Android
            }"
            @click="confirm"
          >
            确定
          </div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    columns: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPicker: false,
    };
  },
  mounted() {
    console.log("xxx", this.$store.state.vantPickeStyle);
  },
  computed: {
    displayValue() {
      return this.value ? this.value : "请选择";
    },
     getItemHeight() {
    if (this.$store.state.Android || this.$store.state.vantPickeStyle) {
      console.log(111);
      return '38';
    } else if (this.$store.state.iphonex && screen.height < 860) {
      console.log('14pro');
      return '38';
    } else if (this.$store.state.iphonex && screen.height > 920) {
      console.log('14promax');
      return '42';
    } else {
      console.log(44444);
      return '42';
    }
  }
  },
  methods: {
    handleColumnChange(value,index) {
      // 处理列改变事件
      // ...
      this.$emit("confirm", value,index);
      this.showPicker = false;
    },
    confirm() {
      // 点击确定按钮事件
      // ...
      this.$refs.picker.confirm();
    },
  },
};
</script>

<style lang="less" scoped>
.van-cell {
  align-items: center;
  padding: 0;
  .h(45);
}
.not-go-index {
  opacity: 0.5;
}
.showBtn {
  // position: relative;
  .h(310);
  .radiusSide(20,20,0,0);

  /deep/ .van-picker__toolbar {
    // .margin(0,0,20,0);
  }

  /deep/ .van-picker__title {
    .fs(16);
    //
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  /deep/ .savebtn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    left: 50%;
    transform: translate(-50%, 0);
    .w(343);
    .h(38);
    .radius(12);
    .fs(16);
     bottom: 5px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    background: #a00003;
    z-index: 2;
  }

  .androidTabBar {
    bottom: 10px;
  }

  .PickxTabBar {
    bottom: 15px;
    // background-color: #999999
  }

  /deep/ .van-picker__columns {
    .h(220) !important;
    .padding(0,0,20,0) !important;
  }
  /deep/ .van-picker {
    .padding(20,0,10,0);
  }
  /deep/ .van-picker__toolbar {
    .h(32);

    .van-picker__title {
      .fs(16);
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }
  /deep/.van-picker-column {
    .h(220);

    .van-picker-column__wrapper {
      .h(220);
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/picker/picker.vue